import { Instance, types } from 'mobx-state-tree'
import { parseBackendUtcDateString } from 'utils/datetimeUtils'

import { IsEditingModel } from '../IsEditingModel'
export enum DiscrepancyReportStatus {
  Resolved = 'resolved',
  Unresolved = 'unresolved',
}
const OperationMadeByModel = types.model('OperationMadeByModel', { name: types.string })

const DiscrepancyReportsBaseModel = IsEditingModel.named('DiscrepancyReportsBaseModel')
  .props({
    creation_timestamp: types.optional(types.maybeNull(types.string), () => new Date().toISOString()),
    created_by: types.maybeNull(OperationMadeByModel),
    vehicle_id: types.number,
    vehicle_name: types.string,
    description: types.string,
    is_resolved: types.boolean,
    resolution_timestamp: types.optional(types.maybeNull(types.string), () => new Date().toISOString()),
    resolved_by: types.maybeNull(OperationMadeByModel),
  })
  .actions((self) => ({
    setDescription(value: typeof self.description) {
      self.description = value
    },
  }))
  .actions((self) => ({
    setVehicleName(value: typeof self.vehicle_name){      
      self.vehicle_name = value
    }
  }))
  .actions((self) => ({
    setVehicleId(value: typeof self.vehicle_id){
      self.vehicle_id = value
    }
  }))
  .views((self) => ({
    get creationDate(): Date | null {
      return self.creation_timestamp ? parseBackendUtcDateString(self.creation_timestamp) : null
    },
    get resolutionDate(): Date | null {
      return self.resolution_timestamp ? parseBackendUtcDateString(self.resolution_timestamp) : null
    },
    get reportStatus(): DiscrepancyReportStatus {
      return self.is_resolved ? DiscrepancyReportStatus.Resolved : DiscrepancyReportStatus.Unresolved
    }
  }))
  

export const ExistingDiscrepancyReportModel = DiscrepancyReportsBaseModel.named('ExistingDiscrepancyReportModel').props({
  id: types.identifierNumber,
})

export const NewDiscrepancyReportModel = DiscrepancyReportsBaseModel.named('NewDiscrepancyReportModel') // No additional props, just what DiscrepancyReportsBaseModel has

export const DiscrepancyReportModel = types.union(ExistingDiscrepancyReportModel, NewDiscrepancyReportModel)

// When a user object is edited, we edit not the instance in the user store, but a temporary clone (in order not to change the object displayed in the table).
// However, in objects with an identifier, and are referenced by this identifier,  we can't have two instances of the same type with the same Id, so we can't create a clone.
// To circumvent this, we define a new type for editing. Now the edit clones are not of the same type, so we don't have this problem.
export const ExistingDiscrepancyReportEditCloneModel = ExistingDiscrepancyReportModel.named('ExistingDiscrepancyReportEditCloneModel')
export const NewDiscrepancyReportEditCloneModel = NewDiscrepancyReportModel.named('NewDiscrepancyReportEditCloneModel')

export const DiscrepancyReportEditCloneModel = types.union(ExistingDiscrepancyReportEditCloneModel, NewDiscrepancyReportEditCloneModel)

export type DiscrepancyReport = Instance<typeof DiscrepancyReportModel>
export type ExistingDiscrepancyReport = Instance<typeof ExistingDiscrepancyReportModel>
export type DiscrepancyReportEditClone = Instance<typeof DiscrepancyReportEditCloneModel>

export const CurrentDiscrepancyReportModel = ExistingDiscrepancyReportModel.named('CurrentDiscrepancyReportModel')
